require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-keep-canada-working-twitter-bot.json") })
        }
      }, "path---projects-keep-canada-working-twitter-bot");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-keep-canada-working-twitter-bot!./.cache/json/projects-keep-canada-working-twitter-bot.json
// module id = 525
// module chunks = 231608221292675